import Tooltip from '@app/setup/tooltip/uikit-tooltip'
import { modifyAndMaintainFocus } from '@app/utils/domHelpers'
import { SfLog } from '@app/adapters/logger'
import $ from 'jquery'
import { SfTime } from '@app/adapters/time'

const LIVE_INPUT_WRAPPER_CLASS = 'live-input-error-wrapper'
const LIVE_INPUT_ERROR_ICON_CLASS = `${LIVE_INPUT_WRAPPER_CLASS}__icon`

export const showValidationError = (
  input: HTMLInputElement,
  error: string
): void => {
  if (input.getAttribute('data-input-invalid') === 'true') {
    return
  }

  modifyAndMaintainFocus(() => {
    window.requestAnimationFrame(() => {
      addErrorIcon(input, error)
    })
  }, input)

  input.classList.add('sf-required')
  input.setAttribute('data-input-invalid', 'true')
}

export const hideValidationError = (input: HTMLInputElement): void => {
  modifyAndMaintainFocus(() => {
    window.requestAnimationFrame(() => {
      removeErrorIcon(input)
    })
  }, input)

  input.classList.remove('sf-required')
  input.removeAttribute('data-input-invalid')
}

function addErrorIcon(el: HTMLElement, error: string): void {
  const wrapper = document.createElement('span')

  const { textAlign, position } = window.getComputedStyle(el)

  wrapper.classList.add(LIVE_INPUT_WRAPPER_CLASS)

  if (textAlign === 'right') {
    wrapper.classList.add(`${LIVE_INPUT_WRAPPER_CLASS}--right`)
  }

  if (position === 'static') {
    wrapper.classList.add(`${LIVE_INPUT_WRAPPER_CLASS}--relative`)
  }

  el.parentNode?.insertBefore(wrapper, el)

  const validationIcon = document.createElement('div')
  validationIcon.classList.add(
    LIVE_INPUT_ERROR_ICON_CLASS,
    'fa',
    'fa-solid',
    'i-unreconciled',
    'sf-c-danger'
  )

  if (textAlign === 'right') {
    validationIcon.classList.add(`${LIVE_INPUT_ERROR_ICON_CLASS}--right`)
  }

  addTooltip(validationIcon, error)

  wrapper.appendChild(el)
  wrapper.appendChild(validationIcon)

  $(document).trigger('tooltipsRendered', [
    validationIcon.parentElement as HTMLElement,
    validationIcon,
  ])
}

function removeErrorIcon(el: HTMLElement): void {
  if (
    el.parentNode instanceof HTMLElement &&
    el.parentNode.classList.contains(LIVE_INPUT_WRAPPER_CLASS)
  ) {
    const validationIcon = el.parentNode.querySelector(
      `.${LIVE_INPUT_ERROR_ICON_CLASS}`
    )

    if (validationIcon) {
      removeTooltip(validationIcon as HTMLElement)
    }

    el.parentNode.replaceWith(el)
  }
}

function addTooltip(validationIcon: HTMLElement, error: string): void {
  validationIcon.setAttribute('title', error)
  validationIcon.setAttribute('rel', 'tooltip')
  validationIcon.setAttribute('data-toggle', 'tooltip')
  validationIcon.setAttribute('data-tooltip-size', 'sm')
}

function removeTooltip(validationIcon: HTMLElement): void {
  validationIcon.removeAttribute('data-original-title')
  validationIcon.removeAttribute('rel')
  validationIcon.removeAttribute('data-toggle')
  validationIcon.removeAttribute('data-tooltip-size')

  // that's the only way to get access to the tooltip instance - using JQuery
  const tooltip = $(validationIcon).data('tooltip-instance') as Tooltip

  if (tooltip) {
    try {
      tooltip.dispose()
    } catch (error) {
      SfLog.error('Error disposing tooltip', { error })
    }
    $(validationIcon).removeData('tooltip-instance')
  }
}

export const parseDateValue = (date: string, format: string): Date | null => {
  if (!date || !date.trim()) {
    return null
  }

  const momentDate = SfTime(date, format)
  if (!momentDate.isValid()) {
    return null
  }

  return momentDate.toDate()
}
